import { createReduxEnhancer, captureException } from '@sentry/react'
import {
	AnyAction,
	applyMiddleware,
	createStore,
	Dispatch,
	Middleware,
	compose,
	Action,
} from 'redux'
import createSagaMiddleware from 'redux-saga'
import logger from 'redux-logger'
import rootSaga from '../store/sagas'
import createRootReducer, { RootState } from './reducers'
import config from '#config'
// import trackerRedux from '@openreplay/tracker-redux'
import { composeWithDevTools } from '@redux-devtools/extension'

const sagaMiddleware = createSagaMiddleware({
	onError: (error) => captureException(error),
})
const composeEnhancers = composeWithDevTools({
	trace: true,
	name: 'smartcheck-flow-orchestrator-client-app',
})

const sentryReduxEnhancer = createReduxEnhancer({})

export default function configureStore() {
	const middlewares: Middleware<any, any, Dispatch<AnyAction>>[] = [
		sagaMiddleware,
		// trackerRedux(),
	]

	if (!config.isProduction) {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		middlewares.push(logger)
	}
	const store = createStore<
		RootState,
		Action<any>,
		Record<string, unknown>,
		Record<string, unknown>
	>(
		createRootReducer(),
		!config.isProduction
			? composeEnhancers(applyMiddleware(...middlewares), sentryReduxEnhancer)
			: compose(applyMiddleware(sagaMiddleware), sentryReduxEnhancer),
	)
	sagaMiddleware.run(rootSaga)

	return store
}
